import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';




export const webinarCounselorApi = createApi({
  baseQuery,
  reducerPath: 'webinarCounselorApi',
  tagTypes: ['webinar'],
  endpoints: (builder) => ({
    // createWebinar: builder.mutation({
    //   query: (data) => ({
    //     url: '/counselor/webinar',
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    // deleteWebinar: builder.mutation({
    //   query: ({ id, data }) => ({
    //     url: `/counselor/delete-webinar/${id}`,
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    getWebinarList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: '/counselor/webinar/list',
        method: 'POST',
        body: filters,
      }),
      keepUnusedDataFor: 0
    }),
    getWebinarDetails: builder.query({
      query: (id) => ({
        url: `/counselor/webinar/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0
    }),
  }),

});

export const {
  // useCreateWebinarMutation,
  // useDeleteWebinarMutation,
  useGetWebinarListQuery,
  useGetWebinarDetailsQuery,
} = webinarCounselorApi;
